<!--
create by melody on 2018/11/4
description:会计分录查询页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
		<template v-if="showModify == false">
			<div class="hdp-uf hdp-uf-dc search-container">
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.primaryLedger')}}：</div>
								<el-select v-model="searchParam.primaryLedger" filterable clearable>
									<el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.postPeriodName')}}：</div>
								<el-date-picker
									style="width:100%;"
							      	v-model="searchParam.postPeriodName"
							      	type="month"
							      	value-format="yyyy-MM"
							      	:placeholder="$t('m.chooseDate')">
							    </el-date-picker>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="12" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.leaseItemNumber')}}：</div>
								<el-input v-model="searchParam.leaseItemNumber" clearable></el-input>
							</div>
						</el-row>
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.sceneType')}}：</div>
								<el-select v-model="searchParam.sceneType" filterable clearable>
									<el-option v-for="(item, index) in sceneTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-row>
					</el-col>

					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.documentType')}}：</div>
								<el-select v-model="searchParam.voucherSceneType" filterable clearable>
									<el-option v-for="(item, index) in voucherSceneList" :key="index" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hfe">
					<el-row>
						<!-- <el-button type="primary" icon="el-icon-search" @click="getDemoList()"> 查 询 </el-button> -->
						<lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
					</el-row>
				</div>
			</div>
			<div class="table-container">
				<el-table :data="tableData" :key="1" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
					<el-table-column type="index"></el-table-column>
					<el-table-column :label="$t('m.primaryLedger')" width="120">
						<template slot-scope="scope">{{ scope.row.primaryLedger }}</template>
					</el-table-column>
					<el-table-column prop="postPeriodName" :label="$t('m.postPeriodName')" width="180"></el-table-column>
					<el-table-column prop="leaseItemNumber" width="300" :label="$t('m.leaseItemNumber')" show-overflow-tooltip></el-table-column>
					<el-table-column prop="sceneType" width="200" :label="$t('m.sceneType')" show-overflow-tooltip></el-table-column>
					<el-table-column prop="voucherSceneType" width="200" :label="$t('m.documentType')" show-overflow-tooltip></el-table-column>
					<el-table-column :label="$t('m.journalHeaderDesc')" width="500" show-overflow-tooltip>
						<template slot-scope="scope">
							<span class="span-style" @click="handleEdit(scope.row)"> {{scope.row.journalHeaderDesc}} </span>
						</template>
					</el-table-column>
				</el-table>
				<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
			</div>
		</template>
		<template v-else>
			<div class="hdp-uf hdp-uf-dc search-container">
				<p>
					<el-button type="text" icon="el-icon-arrow-left" @click="goBack()">{{$t('m.back')}}</el-button>
				</p>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.primaryLedger')}}：</div>
								<el-input v-model="searchParamObj.primaryLedger" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:50%;">{{$t('m.contractCurrency')}}：</div>
								<el-input v-model="searchParamObj.contractCurrency" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.postPeriodName')}}：</div>
								<el-input v-model="searchParamObj.postPeriodName" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:50%;">{{$t('m.currency')}}：</div>
								<el-input v-model="searchParamObj.currency" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.leaseItemNumber')}}：</div>
								<el-input v-model="searchParamObj.leaseItemNumber" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:50%;">{{$t('m.exchangeRate')}}：</div>
								<el-input v-model="searchParamObj.exchangeRate" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
					</el-col>
				</div>
				<div class="hdp-uf hdp-uf-hsb">
					<el-col style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.journalHeaderDesc')}}：</div>
								<el-input v-model="searchParamObj.journalHeaderDesc" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
						<el-row :span="6" :offset="6">
							<div class="hdp-uf" style="width:100%;">
								<div class="hdp-uf hdp-uf-vc" style="width:50%;">{{$t('m.journalName')}}：</div>
								<el-input v-model="searchParamObj.journalName" :disabled="true"></el-input>
							</div>
						</el-row>
					</el-col>
					<el-col :gutter="10" style="width:30%;">
					</el-col>
				</div>
			</div>
			<div class="table-container">
				<el-table :data="tableData2" :key="2" stripe tooltip-effect="dark" style="margin: 24px 0">
					<el-table-column type="index"></el-table-column>
					<el-table-column  :label="$t('m.contentName')" width="200">
						<template slot-scope="scope">{{$commonFunc.alterValue(scope.row.accountingEntry, subentryLineList)}}</template>
					</el-table-column>
					<el-table-column :label="$t('m.titleGroup')" width="300">
						<template slot-scope="scope">{{ scope.row.titleGroup }}</template>
					</el-table-column>
					<el-table-column :label="$t('m.DrContractCurrency')" width="200">
						<template slot-scope="scope">{{ scope.row.debitOrCredit == 'Dr' ? $commonFunc.format(scope.row.amount) : ''}}</template>
					</el-table-column>
					<el-table-column :label="$t('m.CrContractCurrency')" width="200">
						<template slot-scope="scope">{{ scope.row.debitOrCredit == 'Cr' ? $commonFunc.format(scope.row.amount) : ''}}</template>
					</el-table-column>
					<el-table-column :label="$t('m.DrCurrency')" width="200">
						<template slot-scope="scope">{{ scope.row.debitOrCredit == 'Dr' ? $commonFunc.format(scope.row.standardAmount) : ''}}</template>
					</el-table-column>
					<el-table-column :label="$t('m.CrCurrency')" width="200">
						<template slot-scope="scope">{{ scope.row.debitOrCredit == 'Cr' ? $commonFunc.format(scope.row.standardAmount) : ''}}</template>
					</el-table-column>
					<el-table-column prop="entryAbstract" :label="$t('m.entryAbstract')" width="500" show-overflow-tooltip></el-table-column>
				</el-table>
			</div>
		</template>
		
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters
	} from 'vuex'
	export default {
		data () {
			return {
				title: {
					firstTitle: this.$t('m.LapModule'),
                	secondTitle: this.$t('m.OPERATE_MANAGE'),
					thirdTitle: this.$t('m.ACCOUNTING_ENTRIES')
				},
				searchParam: {
					primaryLedger: '',
					postPeriodName: '',
					leaseItemNumber: '',
					sceneType: '',
					voucherSceneType: '',
					pageSize: 10,
					pageNum: 1
				},
				searchParam2: {
					primaryLedger: '',
					journalHeaderId: '',
					leaseItemNumber: '',
					pageSize: 10,
					pageNum: 1
				},
				accountList: [],
				sceneTypeList: [],
				voucherSceneList: [],
				searchParamObj: {
				},
				tableData: [],
				total: 0,
				tableData2: [],
				total2: 0,
				showModify: false,
				currentPage: 1
			}
		},
		methods: {
			getDemoList() {
	            this.$commonFunc.commonRequest('get', '/accounting_entry/list/condition', 'getAccountingList', this.searchParam)
	            .then(res=>{
					this.tableData = res.obj.list
	                this.total = res.obj.total
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
	        },
	        getDemoList2() {
	            this.$commonFunc.commonRequest('get', '/accounting_entry/list/headId', 'getAccountingLineList', this.searchParam2)
	            .then(res=>{
	                this.tableData2 = res.obj.accountingRowListVOList
					// this.total2 = res.obj.total
	                this.searchParamObj['contractCurrency'] = res.obj.contractCurrency
	                this.searchParamObj['exchangeRate'] = res.obj.exchangeRate
	                this.searchParamObj['currency'] = res.obj.currency
	                this.searchParamObj['journalName'] = res.obj.journalName
	                //如果凭证场景为 每期计提折旧 或 计提折旧冲回  合同币和本位币一样  汇率为1
	                if(this.searchParamObj['voucherSceneType'] == '每期计提折旧' || this.searchParamObj['voucherSceneType'] == '计提折旧冲回') {
	                	this.searchParamObj['exchangeRate'] = '1.00'
	                	this.searchParamObj['contractCurrency'] = res.obj.currency
	                }
	                
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
	        },
			handleEdit(row) {
				this.showModify = true
				this.searchParam2.primaryLedger = row.primaryLedger
				this.searchParam2.journalHeaderId = row.journalHeaderId
				this.searchParam2.leaseItemNumber = row.leaseItemNumber
				this.searchParamObj['primaryLedger'] = row.primaryLedger
				this.searchParamObj['postPeriodName'] = row.postPeriodName 
				this.searchParamObj['journalHeaderDesc'] = row.journalHeaderDesc 
				this.searchParamObj['leaseItemNumber'] = row.leaseItemNumber
				this.searchParamObj['voucherSceneType'] = row.voucherSceneType
				this.getDemoList2()
			},
			goBack() {
				this.showModify = false
			},
			getAccountList() {
	            this.$commonFunc.commonRequest('get', '/config/dataPermission/getUserDatePermissionList')
	            .then(res=>{
	                if(res.obj && res.obj.length) {
	                    res.obj.forEach((o,i)=>{
	                        this.accountList.push({label: o.primaryLedgerName, value: o.primaryLedgerName})
	                    })
	                } 
	            })
	            .catch(res=>{
	                this.$message.error(res.message)
	            })
	        }
		},
		async mounted() {
			this.getDemoList()
			this.getAccountList()
			// this.sceneTypeList = await this.$commonFunc.getDataDicList(this.$dataDicObj.SUBJECT_TYPE)
			// this.voucherSceneList = await this.$commonFunc.getDataDicList(this.$dataDicObj.DOCUMENT_TYPE)
			this.voucherSceneList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.documentTypeValueset')], true)
        	this.sceneTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.titileTypeValueset')], true)
        	// this.subentryLineList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.subentryLineValueset')], true)
        	this.subentryLineList = await this.$commonFunc.getValueSetList(this.$valueSetObj.SUBENTRY_LINE_TYPE, true)
		}
	}
</script>
<style scoped>
.search-container {
	background: #ffffff;
	padding: 20px 20px 0 20px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.el-row {
	margin-bottom: 20px;
}
.el-col {
	border-radius: 4px;
}
.block {
	text-align: right;
}
.el-form-item .el-form-item__content {
	margin-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/AccountingEntries.vue